export default __webpack_public_path__ + "static/media/by.36305af1.svg";